import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DataService } from 'src/app/services/data.service';
import { DialogService } from 'src/app/services/dialog.service';
import { FilterService } from 'src/app/services/filter.service';

interface SelectedColumn {
  name: string;
}

@Component({
    selector: 'app-preferences',
    templateUrl: './preferences.component.html',
    styleUrls: ['./preferences.component.scss'],
    standalone: false
})
export class PreferencesComponent {
  columnDef: any[] = [];
  item: any;
  pageName: any;
  defaultColumns: any[] = [];
  selectedColumns: SelectedColumn[] = [];

  searchTerm: string = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) private passedData: any,
    private dialogRef: MatDialogRef<PreferencesComponent>,
    private filterService: FilterService,
    private dataService: DataService,
     private dialogService: DialogService
  ) {
    this.columnDef = (this.passedData?.column || [])
      .filter((f: any) => !['alert', 'alert_col_value', 'action_column'].includes(f.field));

    this.item = this.passedData.item;
    this.pageName = this.passedData.page_name;
    this.defaultColumns = this.passedData.defaultColumns || [];

    const displayColumn = this.passedData.displayColumn || [];
    const displayColNames = displayColumn.map((c: any) => c.headerName || c.field);

    this.selectedColumns = displayColNames
      .filter((name: any) =>
        this.defaultColumns.some(def => def.headerName === name || def.field === name)
      )
      .map((name: any) => ({
        name: name
      }));
  }

  get filteredColumns() {
    if (!this.searchTerm.trim()) {
      return this.defaultColumns;
    }
    const lowerTerm = this.searchTerm.toLowerCase();
    return this.defaultColumns.filter(col =>
      (col.headerName || col.field).toLowerCase().includes(lowerTerm)
    );
  }

  isSelected(colName: string): boolean {
    return this.selectedColumns.some(c => c.name === colName);
  }

  toggleColumn(colName: string): void {
    if (this.isSelected(colName)) {
      this.removeColumn(colName);
    } else {
      this.selectedColumns.push({
        name: colName
      });
    }
  }

  removeColumn(colName: string): void {
    this.selectedColumns = this.selectedColumns.filter(c => c.name !== colName);
  }

  restoreDefaults(): void {
    this.selectedColumns = [
      { name: 'DU_Patient_ID'},
      { name: 'Current Status'},
      { name: 'Alerts'},
      { name: 'Territory'},
      { name: 'Payer Name'}
    ];
  }

  apply(): void {
  if (this.selectedColumns.length > 15) {
    this.dialogService.openSnackBar(
      'Performance is optimized for up to 15 columns and may degrade if this limit is exceeded. Please adjust your selection accordingly.',
      'OK'
    );}

  this.insertPreference();
  this.dialogRef.close(this.selectedColumns);
}

  dropColumn(event: CdkDragDrop<any[]>): void {
    if (event.previousIndex === event.currentIndex) return;

    const movedItem = this.selectedColumns[event.previousIndex];
    this.selectedColumns.splice(event.previousIndex, 1);
    this.selectedColumns.splice(event.currentIndex, 0, movedItem);
  }

  close(): void {
    this.dialogRef.close();
  }

  insertPreference() {
    const obj = {
      dashboard_key: this.passedData.dashboardKey,
      page_name: this.passedData.page_name,
      page_key: this.passedData.pageKey,
      widget_uinique_key: this.passedData.widgetUniqKey,
      employee_key: this.passedData.employeeKey,
      preference_value: JSON.stringify(this.selectedColumns)
    };

    console.log('Inserting Preference:', obj);

    this.dataService.insertPreference(obj).subscribe({
      next: (res: any) => {
        console.log('Preference updated successfully:', res);
      },
      error: (err: any) => {
        console.error('Error updating preference:', err);
      }
    });
  }

  areAllSelected(): boolean {
    return this.defaultColumns.every(col =>
      this.selectedColumns.some(sel => sel.name === (col.headerName || col.field))
    );
  }

  someSelected(): boolean {
    const selectedCount = this.selectedColumns.filter(sel =>
      this.defaultColumns.some(col => sel.name === (col.headerName || col.field))
    ).length;
    return selectedCount > 0 && selectedCount < this.defaultColumns.length;
  }

  toggleSelectAll(checked: boolean): void {
    if (checked) {
      this.selectedColumns = this.defaultColumns.map(col => ({
        name: col.headerName || col.field
      }));
    } else {
      const defaultColNames = this.defaultColumns.map(col => col.headerName || col.field);
      this.selectedColumns = this.selectedColumns.filter(col =>
        !defaultColNames.includes(col.name)
      );
    }
  }
}
